<template>
   <v-container fluid>
      <v-toolbar dense :color="$globalstore.settings_titleclass">
         <v-toolbar-title>
            <template v-if="$vuetify.breakpoint.mobile">
               <v-icon large class="mr-2" @click="goBack()">mdi-chevron-left</v-icon>
            </template>
            Academic Term
         </v-toolbar-title>
         <v-spacer></v-spacer>
         <v-btn small outlined class="primary white--text" @click="addTerm">
            <v-icon small>mdi-plus</v-icon>
            Add
         </v-btn>
      </v-toolbar>
      <v-row class="pt-2">
         <v-col cols="12" md="3">
            <v-select
               v-model="termyearselect"
               :items="termyeardata"
               item-text="termyeartext"
               item-value="id"
               label="Current Term/Year"
               return-object
               :rules="[(v) => !!v || 'Current Term/Year is required']"
            >
            </v-select>
         </v-col>
         <v-col cols="12" md="3">
            <v-select
               v-model="publishyeartermselect"
               :items="termyeardata"
               item-text="termyeartext"
               item-value="id"
               label="Publish CCA Term/Year"
               return-object
               :rules="[(v) => !!v || 'Publish Term/Year is required']"
            >
            </v-select>
         </v-col>
         <v-col cols="12" md="2">
            <v-btn class="mt-3" color="primary white--text" @click="updateCurrentTermYear">
               Save
            </v-btn>
         </v-col>
      </v-row>
      <v-row no-gutters class="pt-1">
         <v-col cols="12" md="12">
            <v-data-table
               dense
               :headers="term_headers"
               :items="termyeardata"
               item-key="id"
               single-select
               @click:row="termRowClick"
            >
               <!-- eslint-disable-next-line -->
               <template #item.actions="{ item }">
                  <v-icon small @click="editTerm(item)">mdi-pencil</v-icon>
                  <v-icon small @click="deleteTerm(item)" class="ml-2">
                     mdi-delete
                  </v-icon>
               </template>
            </v-data-table>
         </v-col>
      </v-row>
      <term-year-form ref="termyearform" @input="onTermYearFormClose"></term-year-form>
      <show-toast ref="toast"></show-toast>
      <confirm-dlg ref="confirm"></confirm-dlg>
   </v-container>
</template>

<script>
   import ConfirmDlg from "@/components/ConfirmDlg.vue";
   import ShowToast from "@/components/showToast.vue";
   import TermYearForm from "@/components/TermYearForm.vue";

   export default {
      inject: ["ShowMessage"],

      components: {
         ConfirmDlg,
         ShowToast,
         TermYearForm,
      },

      data() {
         return {
            term_headers: [
               {
                  text: "ID",
                  value: "id",
                  width: "6%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Term",
                  value: "term",
                  width: "8%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Year",
                  value: "year",
                  width: "15%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Start",
                  value: "term_start",
                  width: "20%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "End",
                  value: "term_end",
                  width: "20%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "",
                  value: "actions",
                  width: "10%",
                  class: this.$globalstore.table_headerclass,
               },
            ],
            termyeardata: [],
            termyearselect: null,
            termyear_id: "",
            publishyeartermselect: null,
         };
      },

      methods: {
         goBack() {
            this.$router.go(-1);
         },

         termRowClick(item, row) {
            row.select(!row.isSelected);
         },

         addTerm() {
            this.$refs.termyearform.open();
         },

         editTerm(item) {
            this.$refs.termyearform.edit(item);
         },

         onTermYearFormClose(payload) {
            if (payload.mode == "add") {
               this.doAddTerm(payload.termdata);
            } else if (payload.mode == "edit") {
               this.doUpdateTerm(payload.termdata);
            }
         },

         async doAddTerm(termdata) {
            let response = await this.$http({
               url: "/common/addterm.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  term: termdata,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.LoadTermYear();
                     this.$refs.toast.display({
                        message: response.data.message,
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         async doUpdateTerm(termdata) {
            let response = await this.$http({
               url: "/common/updateterm.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  term: termdata,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.LoadTermYear();
                     this.$refs.toast.display({
                        message: response.data.message,
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         deleteTerm(item) {
            if (item.id == this.termyearselect.id) {
               this.ShowMessage({
                  title: "Error",
                  message: "Selected term is the current term and cannot be deleted.",
                  color: "red",
               });
            } else {
               this.$refs.confirm
                  .open("Warning", "Are you sure you want to delete " + item.termyeartext + "?", {
                     color: "orange",
                  })
                  .then((reply) => {
                     if (reply) {
                        this.doDeleteTerm(item);
                        this.LoadTermYear();
                     }
                  });
            }
         },

         async doDeleteTerm(term) {
            let response = await this.$http({
               url: "/common/deleteterm.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  term: term,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.LoadTermYear();
                     this.$refs.toast.display({
                        message: response.data.message,
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         async LoadTermYear() {
            let response = await this.$http({
               url: "/common/yearTerm.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.termyeardata = response.data.ytdata;
                     this.termyearselect = this.termyeardata.find(
                        (x) => x.id == this.$globalstore.appsettings.currentyearterm.id
                     );
                  }
               }
            });
         },

         updateCurrentTermYear() {
            if (this.termyearselect) {
               if (this.termyearselect.id != this.$globalstore.appsettings.currentyearterm.id) {
                  this.doUpdateCurrentTermYear();
               }
            }

            if (this.publishyeartermselect) {
               if (
                  this.publishyeartermselect.id !=
                  this.$globalstore.appsettings.cca_publish_yearterm.id
               ) {
                  this.doUpdateCurrentTermYear();
               }
            }
         },

         async doUpdateCurrentTermYear() {
            if (this.termyearselect) {
               await this.$http({
                  url: "/common/updatecurrenttermyear.php",
                  headers: {
                     "Content-Type": "application/x-www-form-urlencoded",
                  },
                  data: {
                     term: this.termyearselect,
                     publishterm: this.publishyeartermselect,
                     userid: this.$globalstore.user.userid,
                     token: this.$globalstore.user.usertoken,
                  },
                  method: "POST",
               }).then((response) => {
                  if (response.data.autherror) {
                     this.$globalstore.user.tokenexpired = true;
                  } else {
                     if (response.data.error) {
                        this.ShowMessage({
                           title: "Error",
                           message: response.data.message,
                           color: "red",
                        });
                     } else {
                        this.reloadAppSettings();
                        this.$refs.toast.display({
                           message: response.data.message,
                           color: this.$globalstore.toast_successclass,
                        });
                     }
                  }
               });
            }
         },

         async reloadAppSettings() {
            let response = await this.$http({
               url: "/common/getappsettings.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {section: "CCA"},
               method: "POST",
            }).then((response) => {
               if (!response.data.error) {
                  this.$globalstore.appsettings = response.data.appsettings;
               } else {
                  this.ShowMessae({
                     title: "Fatal Error",
                     message: "Unable to read application settings.",
                     color: "red",
                  });
               }
            });
         },
      },

      async mounted() {
         await this.LoadTermYear();
         if (this.$globalstore.appsettings.cca_publish_yearterm) {
            this.publishyeartermselect = this.termyeardata.find(
               (x) => x.id == this.$globalstore.appsettings.cca_publish_yearterm.id
            );
         }
      },
   };
</script>
